// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609170250/js/" + chunkId + "." + {"44":"205c52cf","225":"c50f4408","481":"b5fc57e6","486":"e214da33","770":"b16d0147"}[chunkId] + ".0.7773268234325874.chunk.js";
};